export default __webpack_public_path__ + "static/media/swagger-api-docs.2b6a4c50.yaml";